import { useCallback, useContext, useRef, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import TabPanel from "../TabPanel";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import InboundTemplateTree from "../Trees/InboundTemplateTree";
import BlankCSVMenu from "../RightContextMenu/BlankCSVMenu";
import { treeActions } from "../../redux/slices/treeSlice";
import { useEffect } from "react";
import CSVMenu from "../RightContextMenu/CSVMenu";
import XMLMenu from '../RightContextMenu/XMLMenu';
import TreeLoading from "../Trees/TreeLoading";
import datatypes, { FIELD_TYPE, OTHER_TYPE, RECORD_TYPE } from "../../constants/datatypes";
import JsonMenu from "../RightContextMenu/JSONMenu";
import BlankJSONMenu from "../RightContextMenu/BlankJSONMenu";
import BlankXMLMenu from "../RightContextMenu/BlankXMLMenu";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import ErrorModal from "../ItemProperties/Forms/FieldDataValidation/ErrorModal";
import Delete from "../RightContextMenu/ContextActions/Delete";
import SearchButton from "../Search/SearchButton";
import ExpandCollapse from "../Search/ExpandCollapse";

export default function InboundTemplatePanel() {
  const { t } = useTranslation();
  const [currTab, setCurrTab] = useState(1);
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(true);
  const [headerTrailerActive, setHeaderTrailerActive] = useState(true);
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree, leftTree } = useSelector((state) => state.treeData[parentScreen]);
  const leftSelectedNode = leftTree.tree.body.selectedNode;
  const rightSelectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  // const [isCopied,setIsCopied] = useState({ copy: false, paste: false ,dispatchFrom:''})
  const templateHeader = rightTree.tree.templateHeader;
  const content = t('LBL_NO_HEADER_TRAILER_ALLOWED').replace('{0}', templateHeader.FILETYPE).split('\\n').map((str, idx) => <div key={idx}>{str ? str : <br />}</div>);
  const [deleteModal,setDeleteModal] = useState(false);
  const [deleteErrorModal,setDeleteErrorModal] = useState(false);
  const [deleteErrorMessage,setDeleteErrorMessage] = useState('')
  const [expandActions,setExpandActions] = useState({tab:'',keys:[]});
  const isCopied = useSelector((state) => state.treeData[parentScreen].copyPasteState);

  const setIsCopied = (data) => {
    dispatch(treeActions.setCopyPasteState({
      data
    }))
  }

  const handleTabChange = (_event, newValue) => {
    dispatch(
      treeActions.setRightTreeCurrentTab({
        screen: parentScreen,
        data: ["header", "body", "trailer"][newValue]
      })
    );
    setCurrTab(newValue);
  };

  useEffect(() => {
    setDisabled(leftSelectedNode?.type !== 'inboundTemplate');
    dispatch(
      treeActions.setRightTreeCurrentTab({
        screen: parentScreen,
        data: 'body'
      })
    );
    setCurrTab(1);
  }, [leftSelectedNode.key])

  useEffect(() => {
    const fileType = templateHeader?.FILETYPE;
    if (fileType) {
      const showTab =
        fileType === "DATABASE" ||
        fileType === "JSON" ||
        fileType === "XML";
      setHeaderTrailerActive(!showTab);
    } else {
      setHeaderTrailerActive(false);
    }
  }, [templateHeader])

  const handleKeyDown = useCallback((event)=>{
    if (event.ctrlKey && rightSelectedNode) {
      if (event.key === "c" || event.key === "C") {
        setIsCopied({...isCopied, paste: false, copy: true,treeType:parentScreen });
      } else if (event.key === "v" || event.key === "V") {
        setIsCopied({ ...isCopied,paste:true,dispatchFrom:'keyPress',treeType:parentScreen});
      }
    } 
  },[isCopied, rightSelectedNode, parentScreen]);
 
  const handleDelete = (event) =>{
    if (event.key === 'Delete') {
      const {type,TYPE, ICON_DISPLAY} = rightSelectedNode;
      if (["RECORD_TOP", "TEMPLATE_BODY_DOTS"].includes(ICON_DISPLAY)) {
        setDeleteErrorModal(true);
        setDeleteErrorMessage(t('BOX_CANNOT_DEL_TOP_LEVEL_ITEM'));
      } else if (FIELD_TYPE[ICON_DISPLAY] || (RECORD_TYPE[ICON_DISPLAY] && ICON_DISPLAY !== "RECORD_TOP") || OTHER_TYPE[rightSelectedNode?.ICON_DISPLAY] || ICON_DISPLAY?.includes('FIELD_GROUP')) {
        setDeleteModal(true);
      }
    }
  }

  useEffect(() => {
    document?.getElementById("ib-tree")?.focus()
  },[currTab])


  return (
    <>
    <div
      id="ib-tree"
      onKeyDown={(e)=>{
        if (document?.activeElement?.id !== "ib-tree") return;
        handleKeyDown(e,isCopied)
        handleDelete(e)
      }} 
      tabIndex={0}
      className="flex-column"
      style={{outline: 'none', minWidth: "380px"}}
      // onClick={(e) => {
      //   document?.getElementById("ib-tree")?.focus()
      // }}
    >
        <Box>
          <div
            className="flex justify-end"
            style={{
              position: "fixed",
              right: "0",
              height: "32px",
              padding: "0",
              paddingLeft: "8px",
              zIndex: "20",
              marginTop: "-2px",
              backgroundColor: "white",
              borderLeft: "1px solid #e0e0e0",
            }}>
            <SearchButton setExpandActions={setExpandActions} />
            <ExpandCollapse setExpandActions={setExpandActions}/>
          </div>
        </Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={currTab} onChange={handleTabChange}>
          <Tab disabled={disabled} label={t("HEADER")} sx={{fontSize: "12px !important", minWidth: "60px !important"}}/>
          <Tab disabled={disabled} label={t("BODY")} sx={{fontSize: "12px !important", minWidth: "60px !important"}}/>
          <Tab disabled={disabled} label={t("TRAILER")} sx={{fontSize: "12px !important", minWidth: "60px !important"}}/>
        </Tabs>
      </Box>
      <Box sx={{flex: "1", overflow: "auto"}} id="rightTree">
        {/* header */}
        <TabPanel value={currTab} index={0} className="height-100">
          {headerTrailerActive ? <div className="height-100">
            {rightTree.tree.header.translatedData?.length > 0 ? (
              <InboundTemplateTree expandActions={expandActions}  tab="header" />
            ) : (
              <div className="panel-no-data"></div>
            )}
          </div> : <div className="panel-no-data">{content}</div>}
        </TabPanel>

        {/* body */}
        <TabPanel value={currTab} index={1} className={"height-100"}>
          <div className="height-100">
            {
              rightTree.tree.body.translatedData?.length > 0 ?
                <InboundTemplateTree expandActions={expandActions} tab="body" />
                : rightTree.loading ? <TreeLoading />
                  : rightTree.fetchError ? <div className="panel-fetch-error">{t('ERROR_FETCHING_TEMPLATE')}</div>
                    : <div className="panel-no-data">{t("LBL_NO_IN_SEL")}</div>
            }
          </div>
        </TabPanel>

        {/* trailer */}
        {/* OverFlowing Trailer Section, So added Class */}
        <TabPanel className={"height-100"} value={currTab} index={2}>
          {headerTrailerActive ? <div className="height-100">
            {rightTree.tree.trailer.translatedData?.length > 0 ? (
              <InboundTemplateTree expandActions={expandActions} tab="trailer" />
            ) : (
              <div className="panel-no-data"></div>
            )}
          </div> : <div className="panel-no-data">{content}</div>}
        </TabPanel>
        {(currTab === 1 || headerTrailerActive) && !["XML","JSON"].includes(templateHeader.FILETYPE) && <BlankCSVMenu isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTree"} />}
        {(currTab === 1 || headerTrailerActive) && !["XML","JSON"].includes(templateHeader.FILETYPE) && <CSVMenu  isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTree"} />}
        {templateHeader.FILETYPE === "XML" && (currTab === 1 || headerTrailerActive) && <XMLMenu isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTree"} />}
        {templateHeader.FILETYPE === "XML" && (currTab === 1 || headerTrailerActive) && <BlankXMLMenu isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTree"} />}
        {templateHeader.FILETYPE === "JSON" && (currTab === 1 || headerTrailerActive) && <JsonMenu isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTree"} />}
        {templateHeader.FILETYPE === "JSON" && (currTab === 1 || headerTrailerActive) && <BlankJSONMenu isCopied={isCopied} setIsCopied={setIsCopied} targetId={"rightTree"} />}
      </Box>
    </div>
    {deleteModal && <Delete
        openModal={deleteModal}
        toggle={() => setDeleteModal(false)}></Delete>
      }
      {deleteErrorModal && <ErrorModal
       errorModal={deleteErrorModal}
       errorMessage={deleteErrorMessage}
       handleErrorModal={()=> setDeleteErrorModal(false)}
      ></ErrorModal>}
    </>
  );
}
